import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    height: '100%',
  },
  labelBox: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    position: 'relative',
  },
  iconButton: {
    cursor: 'help',
  },
  infoIconSup: {
    position: 'absolute',
    bottom: 2,
    left: 0,
    fontSize: 16,
  },
  label: {
    fontWeight: 800,
    textTransform: 'uppercase',
  },
  valueBox: {
    color: theme.palette.primary.main,
    height: '100%',
    minHeight: 190,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.common.white,
    borderRadius: 4,
  },
  value: {
    fontSize: 92,
  },
}))

export default styles
